import React from "react";

/**
 * size = large/medium/small
 */
export function List({ size = "large", children }) {
  return <div className={`list list--${size}`}>{children}</div>;
}
